import { z } from 'zod';

import { Nullable } from '@clearverify/types';

import { PeoWhere, QueryMode } from 'src/api';
import { COMPANY_SEARCH_CATEGORY_MAP } from 'src/constants/company';
import { getEmailDomainForSearch } from 'src/utils/email';

export const prepareSearchFilterByCategories = (
  searchValue: Nullable<string>,
  searchCategory: Nullable<string>,
): PeoWhere => {
  if (!searchValue) return {};
  // eslint-disable-next-line no-param-reassign
  if (!searchCategory) searchCategory = COMPANY_SEARCH_CATEGORY_MAP.displayName;

  if (searchCategory === COMPANY_SEARCH_CATEGORY_MAP.displayName) {
    return {
      displayName: {
        contains: searchValue,
        mode: QueryMode.Insensitive,
      },
    };
  }

  if (searchCategory === COMPANY_SEARCH_CATEGORY_MAP.staffEmail) {
    const { success, data: staffEmail } = z.string().trim().email().safeParse(searchValue);
    if (!success || !staffEmail) return {};

    return {
      peoStaffs: {
        some: {
          user: {
            email: { equals: staffEmail.toLowerCase() },
          },
        },
      },
    };
  }

  if (searchCategory === COMPANY_SEARCH_CATEGORY_MAP.emailDomain) {
    const emailDomain = getEmailDomainForSearch(searchValue);
    if (!emailDomain) return {};

    return {
      OR: [
        { contactEmail: { endsWith: emailDomain.toLowerCase() } },
        {
          peoStaffs: {
            some: {
              user: { email: { endsWith: emailDomain.toLowerCase() } },
            },
          },
        },
      ],
    };
  }

  return {};
};
